import Database from "./db";

export default class DatabaseHelper extends Database {
  constructor(local, remote, primary = 0) {
    super(local, remote, primary);
    this.createIndices(["startTime", "endTime", "type", 'status'], ["_id"]);
  }

  fetchRecords(selector) {
    return this.find({ selector: { ...selector } });
  }

  addIndex(...fields) {
    this.createIndices(fields);
  }
}
